import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
// import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
// import { Tabs, Tab } from 'material-ui/Tabs'
import Tabs, { Tab } from 'material-ui-next/Tabs'
import AppBar from 'material-ui-next/AppBar'
import withStyles from 'material-ui-next/styles/withStyles'
import { themeColors } from '../../../styles/theme'

// const MessagesToolbar = ({ pageMatch, match, history }) => (
//   <Tabs value={pageMatch.params.type}>
//     <Tab
//       label="In arrivo"
//       value="inbox"
//       onActive={() => history.push('/messages/inbox')}
//     />
//     <Tab
//       label="Inviati"
//       value="outbox"
//       onActive={() => history.push('/messages/outbox')}
//     />
//   </Tabs>
// )

const styles = theme => ({
  root: {
    flexGrow: 1,
    color: '#fff',
    backgroundColor: '#00BCD4',
  },
  fifty: {
    minWidth: '50%',
  },
  label: {
    fontSize: 13,
  },
})

class MessagesToolbar extends PureComponent {
  state = {
    value: 'inbox',
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }

  render() {
    const { pageMatch, match, history, classes } = this.props
    const { value } = this.state
    return (
      <Tabs
        className={classes.root}
        fullWidth
        onChange={this.handleChange}
        indicatorColor={themeColors.secondary}
        value={value}>
        <Tab
          label="In arrivo"
          value="inbox"
          classes={{ root: classes.fifty, label: classes.label }}
          onClick={() => history.push('/messages/inbox')}
        />
        <Tab
          label="Inviati"
          value="outbox"
          classes={{ root: classes.fifty, label: classes.label }}
          onClick={() => history.push('/messages/outbox')}
        />
      </Tabs>
    )
  }
}

export default withRouter(withStyles(styles)(MessagesToolbar))



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/MessagesToolbar.js